import { AddCourseToCartComponent } from 'src/app/add-course-to-cart/add-course-to-cart.component';
import { AuthorBioModalComponent } from 'src/app/author-bio-modal/author-bio-modal.component';
import { CommonModule } from '@angular/common';
import { CourseAuthorSeoListComponent } from 'src/app/course-author-seo-list/course-author-seo-list.component';
import { CourseContentDisplayComponent } from 'src/app/course-content-display/course-content-display.component';
import { CourseContentDisplayLinkComponent } from 'src/app/course-content-display-link/course-content-display-link.component';
import { CourseContentDisplayPDFComponent } from 'src/app/course-content-display-pdf/course-content-display-pdf.component';
import { CourseContentDisplaySplashOnlyComponent } from 'src/app/course-content-display-splash-only/course-content-display-splash-only.component';
import { CourseContentDisplayWebinarComponent } from 'src/app/course-content-display-webinar/course-content-display-webinar.component';
import { CourseEvaluationComponent } from 'src/app/course-evaluation/course-evaluation.component';
import { CourseViewComponent } from 'src/app/course-view/course-view.component';
import { CourseViewRoutingModule } from './course-view-routing.module';
import { HelpPageComponent } from 'src/app/help-page/help-page.component';
import { LmsApiModule } from 'lms-api';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RelatedCourseListComponent } from 'src/app/related-course-list/related-course-list.component';
import { SharedModule } from '../shared/shared.module';
import { StateApprovalAlertComponent } from 'src/app/state-approval-alert/state-approval-alert.component';
import { SupplementaryMaterialListComponent } from 'src/app/supplementary-material-list/supplementary-material-list.component';
import { VideoJsPlayerComponent } from 'src/app/video-js-player/video-js-player.component';
import { RelatedBundleListComponent } from 'src/app/related-bundle-list/related-bundle-list.component';

@NgModule({
  declarations: [
    CourseViewComponent,
    RelatedBundleListComponent,
    RelatedCourseListComponent,
    SupplementaryMaterialListComponent,
    AuthorBioModalComponent,
    CourseContentDisplayComponent,
    CourseContentDisplayWebinarComponent,
    CourseContentDisplayPDFComponent,
    CourseContentDisplayLinkComponent,
    CourseContentDisplaySplashOnlyComponent,
    StateApprovalAlertComponent,
    CourseEvaluationComponent,
    AddCourseToCartComponent,
    VideoJsPlayerComponent,
    HelpPageComponent,
    CourseAuthorSeoListComponent
  ],
  imports: [
    CommonModule,
    CourseViewRoutingModule,
    LmsApiModule,
    SharedModule,
    ReactiveFormsModule
  ]
})
export class CourseViewModule { }
